import { Box, HStack, Icon, Text, Badge, Spinner, Alert } from '@chakra-ui/react';
import { FiList } from 'react-icons/fi'
import { useContactListDetail } from '../../hooks/useContactList'

interface ListContextBannerProps {
  listId: string
}

export function ListContextBanner({ listId }: ListContextBannerProps) {
  const { data: list, isLoading, error } = useContactListDetail(listId)

  if (isLoading) {
    return (
      <Box bg="info.subtle" p={4} borderRadius="md">
        <HStack gap={2}>
          <Spinner size="sm" color="accent" />
          <Text fontSize="sm" color="gray.600">
            Loading list context...
          </Text>
        </HStack>
      </Box>
    );
  }

  if (!!error || !list) {
    return (
      <Alert.Root status="warning" borderRadius="md" size="sm">
        <Alert.Indicator />Unable to load list context
              </Alert.Root>
    );
  }

  const getStrategyColor = (strategy: string) => {
    switch (strategy) {
      case 'Dynamic':
        return 'green'
      case 'AutoDaily':
        return 'blue'
      case 'Manual':
        return 'orange'
      case 'Locked':
        return 'gray'
      default:
        return 'gray'
    }
  }

  return (
    <Box bg="info.subtle" p={4} borderRadius="md" borderLeft="4px solid" borderColor="info.fg">
      <HStack gap={3} flexWrap="wrap">
        <Icon color="info.fg" boxSize={5} asChild><FiList /></Icon>
        <Text fontWeight="semibold" color="gray.800">
          Working with:
        </Text>
        <Text fontWeight="bold" color="info.fg">
          "{list.label}"
        </Text>
        <Text color="gray.600" fontSize="sm">
          •
        </Text>
        <Text color="gray.700" fontSize="sm">
          {list.memberCount?.toLocaleString() ?? 0} contacts
        </Text>
        <Text color="gray.600" fontSize="sm">
          •
        </Text>
        <Badge colorPalette={getStrategyColor(list.refreshStrategy)} fontSize="xs">
          {list.refreshStrategy}
        </Badge>
      </HStack>
    </Box>
  );
}
